import { getLogger } from '../logger';

/**
 * Executes the provided block and emits how long it took to Graphene.
 *
 * @internal
 */
export async function timed<T>(fn: () => Promise<T>, metricsName: string): Promise<T> {
  const t0 = performance.now();

  try {
    return await fn();
  } finally {
    const milliSec = Math.round(performance.now() - t0);
    log.debug(`${metricsName}=${milliSec}ms`);
  }
}

const log = getLogger('timed');
